import React from 'react';
import { Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';

export const CallAvailabilityButton = ({ available, occupied, onClick, testId, className = '', disabled = false, children }) => {
  const { t } = useTranslation('o2o');
  if (!available && !occupied) return null;
  return <Button variant="secondary" onClick={onClick} disabled={disabled} data-testid={testId}
    data-call-state={occupied ? 'busy' : 'available'}
    className={`font-semibold text-white transition-colors ${occupied ? 'bg-red-700 hover:bg-red-600' : 'bg-emerald-700 hover:bg-emerald-600'} ${className}`}>
    <Phone className="mr-1.5 h-4 w-4 shrink-0" />{t(occupied ? 'call_availability.busy' : 'call_availability.call')}{children}
  </Button>;
};